module.exports = __webpack_public_path__ + "img/desire_004.fc0c155.png";